// extracted by mini-css-extract-plugin
module.exports = {"FileUploadArea":"FileUploadArea_FileUploadArea__39TbP","isDragging":"FileUploadArea_isDragging__2K_Zk","isFullWidth":"FileUploadArea_isFullWidth__3GZmp"};